/**
 * Generic Rendering states for control element
 */ export var ControlRenderMode;
(function(ControlRenderMode) {
    /** Control element will render normally */ ControlRenderMode[ControlRenderMode["Default"] = 0] = "Default";
    /** Control element will render in disabled mode */ ControlRenderMode[ControlRenderMode["Disabled"] = 1] = "Disabled";
    /** Control element will not be rendered */ ControlRenderMode[ControlRenderMode["Hidden"] = 2] = "Hidden";
})(ControlRenderMode || (ControlRenderMode = {}));
